<template>
<v-container>
      <div class="d-flex align-center" >
        <div class="">
          <v-img
            v-if="$vuetify.breakpoint.mdAndDown"
            :width="mdWidth"
            src="../login/css/img/logomark_nexus.svg"
            alt="Nexus brand logomark"
          />
          <v-img
            v-if="$vuetify.breakpoint.lgAndUp"
            :width="lgWidth"
            src="../login/css/img/logomark_nexus.svg"
            alt="Nexus brand logomark"
          />
        </div>
        <div class="mt-0 mt-md-1 ml-1 ml-md-2">
          <div class="logo-color text-subtitle-2 text-lg-h5"><b>Certificate Manager</b></div>
          <div>
            <div class="custom-margin">
              <div v-if="$vuetify.breakpoint.smAndDown" class="logo-color text-caption mr-2 font-weight-regular">CM Web UI</div>
              <div v-if="$vuetify.breakpoint.smAndDown && showVersion" class="version-style">Version {{ version }}</div>

              <span v-if="!$vuetify.breakpoint.smAndDown" class="logo-color text-caption text-lg-subtitle-2 mr-2 font-weight-regular">CM Web UI</span>
              <span v-if="!$vuetify.breakpoint.smAndDown && showVersion" class="version-style">Version {{ version }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-container>
</template>
<script>

import { WEB_UI_VERSION } from "@/config/constants";

export default {
  props:["showVersion", "mdWidth", 'lgWidth'],
  data(){
        return {
          version: WEB_UI_VERSION
        }
    }
}
</script>
<style scoped lang="scss">
.custom-margin {
  margin-top: -7px;
}
</style>